export default __webpack_public_path__ + "static/media/toplion01.ae9e2333.png";